import type { KeyboardEvent } from 'react';

export type CrossFilterA11yProps = {
  role: 'button';
  tabIndex: number;
  'aria-pressed': boolean;
  onKeyDown: (event: KeyboardEvent) => void;
};

/**
 * Ready to spread onto a chart bar or a table row so cross-filtering works
 * from the keyboard: Enter and Space both activate it exactly like a click,
 * and aria-pressed reports whether this value is the active cross-filter.
 * Pair with announceLensFilter(describeCrossFilterAnnouncement(...)) from
 * lensAnnouncer so the resulting filter is announced too.
 */
export function crossFilterA11yProps(active: boolean, onActivate: () => void): CrossFilterA11yProps {
  return {
    role: 'button',
    tabIndex: 0,
    'aria-pressed': active,
    onKeyDown: (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onActivate();
      }
    },
  };
}
